module.exports = __webpack_public_path__ + "static/media/Cooleaf-Photo-Upload.716f58c4.gif";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/Cooleaf/Cooleaf-Photo-Upload.gif
// module id = 130
// module chunks = 0